import store from '@ps/store'
import {
  isBanEditNode,
  isVirtualNode,
} from '@ps/store/workbench/stage/config/layer-config'
import { getNodeByShape } from '@ps/store/workbench/stage/utils/helper'

/**
 * 吸附距离
 */
export const GUIDELINE_OFFSET = 5

/**
 * 只有开启吸附状态，并且是虚拟节点才能被吸附, 如果是虚拟节点的ghost，则不能被吸附 TODO
 * @param shape
 */
export const allowSnap = (shape: any): boolean => {
  const node = getNodeByShape(shape)
  return (
    store.state.workspace.stage.allowSnapping &&
    isVirtualNode(shape) &&
    !isBanEditNode(node)
  )
}
